<template>
  <div class="tip-list">
    <el-popover placement="left" title="" trigger="hover">
      <div slot="reference" class="tip-item">
        <img src="../../assets/img/wechat-fill.png" alt="微信图标" />
        <span>添加微信</span>
      </div>

      <div style="width: 240px;">
        <img
          style="width: 100%;"
          src="../../assets/img/wx-qr-code.png"
          alt="微信二维码"
        />
      </div>
    </el-popover>

    <el-popover
      placement="left"
      title=""
      width="200"
      trigger="hover"
      content="电话：400-8888-628"
    >
      <div slot="reference" class="tip-item">
        <i class="el-icon-service"></i>
        <span>电话客服</span>
      </div>
    </el-popover>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.tip-list {
  position: fixed;
  right: 8px;
  bottom: 100px;
  z-index: 10;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  .code-modal {
    padding: 10px;
    width: 120px;
    right: 80px;
    top: 20px;
    position: absolute;
    background: #fff;
    box-shadow: 0px 1px 6px 1px rgba(0, 0, 0, 0.16);
    p {
      font-size: 12px;
    }
  }
  .tip-item {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: #fff;
    font-size: 0.75rem;
    padding: 0.5rem;
    margin: 10px 0;
    border-radius: 6px;
    .el-icon-service {
      font-size: 30px;
      color: #409eff;
    }
    span {
      margin-top: 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/InvitCode.vue